<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      height="calc(100vh - 280px)"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Empresa</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
          <v-btn
            v-show="desserts.length == 0"
            color="primary"
            dark
            class="mb-2"
            @click="dialog = true"
            >Novo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.src_modulo="{ item }">
        <v-icon>{{ item.src_modulo }}</v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:item.action_delete="{ item }">
        <v-icon title="Remover Módulo" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-0 ma-0">
        <v-card-title class="pa-0">
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn color="primary" title="Exportar Para Excel" @click="save" small>
              <v-icon>mdi-saved</v-icon> Salvar
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="px-3 py-0">
          <p class="pa-0 my-3 subtitle-2">CADASTRO E CONFIGURAÇÃO DA EMPRESA</p>

          <div class="d-flex">
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.razao_social"
                autofocus
                label="Razao Social*"
                class="mr-2"
                dense
                :error-messages="razaoSocialErrors"
                @input="$v.editedItem.razao_social.$touch()"
                @blur="$v.editedItem.razao_social.$touch()"
              ></v-text-field>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.cnpj"
                label="CNPJ*"
                v-mask="maskCnpj"
                class="ml-2 mr-2"
                dense
                :error-messages="cnpjErrors"
                @input="$v.editedItem.cnpj.$touch()"
                @blur="$v.editedItem.cnpj.$touch()"
              ></v-text-field>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.licencas"
                label="Número de Licenca*"
                class="ml-2"
                dense
                :error-messages="licencaErrors"
                @input="$v.editedItem.licencas.$touch()"
                @blur="$v.editedItem.licencas.$touch()"
              ></v-text-field>
            </v-col>
          </div>
          <div class="d-flex">
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.contrato"
                label="Contrato*"
                class=",l-2 mr-2"
                dense
                :error-messages="contratoErrors"
                @input="$v.editedItem.contrato.$touch()"
                @blur="$v.editedItem.contrato.$touch()"
              ></v-text-field>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.data_inicio"
                type="date"
                label="Data Inicial*"
                class="ml-2 mr-2"
                dense
                :error-messages="dataInicialErrors"
                @input="$v.editedItem.data_inicio.$touch()"
                @blur="$v.editedItem.data_inicio.$touch()"
              ></v-text-field>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-text-field
                outlined
                v-model="editedItem.data_fim"
                type="date"
                label="Data Final*"
                class="ml-2"
                dense
                :error-messages="dataFimErrors"
                @input="$v.editedItem.data_fim.$touch()"
                @blur="$v.editedItem.data_fim.$touch()"
              ></v-text-field>
            </v-col>
          </div>

          <v-divider class="mb-6 mt-n1"></v-divider>

          <div class="d-flex">
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.id_erp"
                :items="selects.erps.items"
                small-chips
                label="ERP Integrado*"
                height="10"
                outlined
                dense
                item-value="id"
                item-text="sigla_desc"
                class="mr-2"
                :error-messages="id_erpErrors"
                @input="$v.editedItem.id_erp.$touch()"
                @blur="$v.editedItem.id_erp.$touch()"
              ></v-select>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.filial_compra"
                :items="selects.compraFilial.items"
                small-chips
                label="Ativar Compra por Filial*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="ml-2 mr-2"
                dense
                :error-messages="compraFilialErrors"
                @input="$v.editedItem.filial_compra.$touch()"
                @blur="$v.editedItem.filial_compra.$touch()"
              ></v-select>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.fator_atuacao"
                :items="selects.fatorAtuacao.items"
                small-chips
                label="Ativar Fator de Atuação*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="ml-2"
                dense
                :error-messages="fatorAtuacaoErrors"
                @input="$v.editedItem.fator_atuacao.$touch()"
                @blur="$v.editedItem.fator_atuacao.$touch()"
              ></v-select>
            </v-col>
          </div>
          <div class="d-flex">
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.filtro_comprador"
                :items="selects.fatorAtuacao.items"
                small-chips
                label="Filtro Comprador*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="mr-2"
                dense
                :error-messages="filtroCompradorErrors"
                @input="$v.editedItem.filtro_comprador.$touch()"
                @blur="$v.editedItem.filtro_comprador.$touch()"
              ></v-select>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.filtro_segmento"
                :items="selects.fatorAtuacao.items"
                small-chips
                label="Filtro de Segmento*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="ml-2 mr-2"
                dense
                :error-messages="filtroSegmentoErrors"
                @input="$v.editedItem.filtro_segmento.$touch()"
                @blur="$v.editedItem.filtro_segmento.$touch()"
              ></v-select>
            </v-col>
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.multiplo_compras"
                :items="selects.fatorAtuacao.items"
                small-chips
                label="Multiplo de Compras*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="ml-2"
                dense
                :error-messages="multiploCompraErrors"
                @input="$v.editedItem.multiplo_compras.$touch()"
                @blur="$v.editedItem.multiplo_compras.$touch()"
              ></v-select>
            </v-col>
          </div>
          <div class="d-flex">
            <v-col class="pa-0" cols="4" xs="4">
              <v-select
                v-model="editedItem.converter_emb_master"
                :items="selects.fatorAtuacao.items"
                small-chips
                label="Converter Embalagem*"
                height="10"
                outlined
                item-value="id"
                item-text="value"
                class="mr-2"
                dense
                :error-messages="converterEmbErrors"
                @input="$v.editedItem.converter_emb_master.$touch()"
                @blur="$v.editedItem.converter_emb_master.$touch()"
              ></v-select>
            </v-col>
          </div>

          <v-divider class="mb-6 mt-n1"></v-divider>

          <div class="d-flex">
            <v-col cols="4" class="pa-0 pr-2" >
              <FormInputUploadImagem
                :dialog="dialog"
                :empresa="editedItem"
                @upload-logo="initialize();editedItem.logo_cliente = $event"
              />
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Api from "./../../api/cfg";
import FormInputUploadImagem from "./FormInputUploadImagem.vue";

import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  components: { FormInputUploadImagem },
  data: () => ({
    maskCnpj: "##.###.###/####-##",
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Razao Social",
        align: "left",
        value: "razao_social",
      },
      {
        text: "CNPJ",
        align: "left",
        value: "cnpj",
      },
      {
        text: "Numero Licenca",
        align: "left",
        value: "licencas",
      },
      {
        text: "Contrato",
        align: "left",
        value: "contrato",
      },
      {
        text: "Data Inicial",
        align: "left",
        value: "data_inicio",
      },
      {
        text: "Data Final",
        align: "left",
        value: "data_fim",
      },
      {
        text: "ERP Integrado",
        align: "left",
        value: "sigla_erp",
      },
      { text: "Ações", value: "action", sortable: false },
      { text: "", value: "action_delete", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      razao_social: "",
      cnpj: "",
      licencas: "",
      contrato: "",
      data_inicio: "",
      data_fim: "",
      filial_compra: "",
      fator_atuacao: "",
      filtro_comprador: "",
      filtro_segmento: "",
      multiplo_compras: "",
      converter_emb_master: "",
      id_erp: "",
      logo_cliente: ""
    },
    defaultItem: {
      id: "",
      razao_social: "",
      cnpj: "",
      licencas: "",
      contrato: "",
      data_inicio: "",
      data_fim: "",
      filial_compra: "",
      fator_atuacao: "",
      filtro_comprador: "",
      filtro_segmento: "",
      multiplo_compras: "",
      converter_emb_master: "",
      id_erp: "",
      logo_cliente: ""
    },
    selects: {
      empresas: {
        items: [],
      },
      compraFilial: {
        items: [
          { id: "S", value: "SIM" },
          { id: "N", value: "NÃO" },
        ],
      },
      fatorAtuacao: {
        items: [
          { id: "S", value: "SIM" },
          { id: "N", value: "NÃO" },
        ],
      },
      erps: {
        items: [],
      },
    },
  }),

  validations: {
    editedItem: {
      razao_social: {
        required,
      },
      cnpj: {
        required,
      },
      licencas: {
        required,
      },
      contrato: {
        required,
      },
      data_inicio: {
        required,
      },
      data_fim: {
        required,
      },
      filial_compra: {
        required,
      },
      fator_atuacao: {
        required,
      },
      filtro_comprador: {
        required,
      },
      multiplo_compras: {
        required,
      },
      filtro_segmento: {
        required,
      },
      converter_emb_master: {
        required,
      },
      id_erp: {
        required,
      },
    },
  },

  computed: {
    razaoSocialErrors() {
      const errors = [];
      if (!this.$v.editedItem.razao_social.$dirty) return errors;
      !this.$v.editedItem.razao_social.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    cnpjErrors() {
      const errors = [];
      if (!this.$v.editedItem.cnpj.$dirty) return errors;
      !this.$v.editedItem.cnpj.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    licencaErrors() {
      const errors = [];
      if (!this.$v.editedItem.licencas.$dirty) return errors;
      !this.$v.editedItem.licencas.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    contratoErrors() {
      const errors = [];
      if (!this.$v.editedItem.contrato.$dirty) return errors;
      !this.$v.editedItem.contrato.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    dataInicialErrors() {
      const errors = [];
      if (!this.$v.editedItem.data_inicio.$dirty) return errors;
      !this.$v.editedItem.data_inicio.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    dataFimErrors() {
      const errors = [];
      if (!this.$v.editedItem.data_fim.$dirty) return errors;
      !this.$v.editedItem.data_fim.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    compraFilialErrors() {
      const errors = [];
      if (!this.$v.editedItem.filial_compra.$dirty) return errors;
      !this.$v.editedItem.filial_compra.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    fatorAtuacaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.fator_atuacao.$dirty) return errors;
      !this.$v.editedItem.fator_atuacao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    filtroCompradorErrors() {
      const errors = [];
      if (!this.$v.editedItem.filtro_comprador.$dirty) return errors;
      !this.$v.editedItem.filtro_comprador.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    multiploCompraErrors() {
      const errors = [];
      if (!this.$v.editedItem.multiplo_compras.$dirty) return errors;
      !this.$v.editedItem.multiplo_compras.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    filtroSegmentoErrors() {
      const errors = [];
      if (!this.$v.editedItem.filtro_segmento.$dirty) return errors;
      !this.$v.editedItem.filtro_segmento.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    converterEmbErrors() {
      const errors = [];
      if (!this.$v.editedItem.converter_emb_master.$dirty) return errors;
      !this.$v.editedItem.converter_emb_master.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    id_erpErrors() {
      const errors = [];
      if (!this.$v.editedItem.id_erp.$dirty) return errors;
      !this.$v.editedItem.id_erp.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Empresa" : "Editar Empresa";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
    this.buscarErps();
  },

  methods: {
    buscarErps() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        Api.getSistemasIntegracao(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.selects.erps.items = response.data.sistemas;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        Api.getEmpresas(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.empresas;
            }
          })
          .catch(() => {
            this.Helpers.logout()
          })
      )
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover a Empresa?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          Api.delEmpresa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);

      this.$v.$reset();
    },

    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          Api.addEmpresa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );

        this.close();
      }
    },
  },
};
</script>
<style scoped>
</style>
